import { render, staticRenderFns } from "./ellipShow.vue?vue&type=template&id=26b41339&scoped=true"
import script from "./ellipShow.vue?vue&type=script&lang=ts"
export * from "./ellipShow.vue?vue&type=script&lang=ts"
import style0 from "./ellipShow.vue?vue&type=style&index=0&id=26b41339&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b41339",
  null
  
)

export default component.exports